module.exports = __webpack_public_path__ + "img/115.3.6cd5d750.png";